<div class="tw-flex tw-flex-col tw-gap-3">
  <textarea
    #answerTextarea
    class="tw-w-full tw-h-44 tw-p-4 tw-rounded-xl tw-bg-gray-80 tw-border-0 tw-text-300 tw-text-gray-800 placeholder:tw-text-gray-400 tw-resize-none"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [ngModel]="draft()"
    (ngModelChange)="onDraftChange($event)"></textarea>
  @if (showVoice()) {
    <div>
      <button csButton="outlined" size="small" type="button"
        class="tw-h-fit tw-px-3 tw-py-1 tw-m-0"
        [disabled]="disabled()"
        (click)="onTapToSpeak($event)">
        <span class="tw-flex tw-items-center tw-gap-1">
          <span i18n="@@chatVoiceTapToSpeak" class="tw-text-200">Tap to Speak</span>
          <cs-icon iconName="quiz-mic" class="tw-w-3 tw-h-3 tw-text-teal-600"></cs-icon>
        </span>
      </button>
      <!-- Kept only for its speech-to-text logic (viewChild.onClick + transcript); its own mic UI is hidden. -->
      <voice-mic-input class="tw-hidden" (transcript)="onVoiceTranscript($event)" />
    </div>
  }
</div>
